module.exports = __webpack_public_path__ + "img/cdt.f65a6ba1.svg";